<template>
  <div id="characteristics-content">
    <VTable v-if="product.sku" id="characteristics-table" class="w-100">
      <tbody>
        <tr class="px-3" v-if="product.sku">
          <th class="pa-3 w-50" scope="row">
            {{ translate('fe_app_pdp_attribute_item_number') }}
          </th>
          <td class="pa-3 w-50 font-size-m font-weight-bold" itemprop="sku">
            {{ product.sku }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_type">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_wine_type') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            <a class="link-winered" :href="links['wine_type']">
              {{ product.details.wine_type
              }}<span
                v-if="!isAlcoholic && product.details.wine_type_key !== 12"
                >, {{ product.alcohol_content_value }}</span
              >
            </a>
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_sub_type">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_wine_sub_type') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            <a class="link-winered" :href="links['wine_sub_type']">
              {{ product.details.wine_sub_type }}
            </a>
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_grape_variety">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_grape_variety') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            <a class="link-winered" :href="links['wine_grape_variety']">
              {{ product.details.wine_grape_variety }}
            </a>
            <div
              v-if="product.details.wine_grape_variety_cuvee"
              class="font-italic"
            >
              {{ product.details.wine_grape_variety_cuvee }}
            </div>
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_quality">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_wine_quality') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.wine_quality }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.vdp_classification">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_vdp_classification') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.vdp_classification }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_location">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_wine_location') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.wine_location }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.country">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_country') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            <span v-for="(country, index) in calculated.countries" :key="index">
              <a class="link-winered" :href="links['country'][country]">{{
                country
              }}</a>
              <span v-show="calculated.countries.length - 1 !== index">, </span>
            </span>
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.region">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_region') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            <a class="link-winered" :href="links['region']">{{
              product.details.region
            }}</a>
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_appellation">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_appellation') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.wine_appellation }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_year">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_vintage') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.wine_year }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_maker_type">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_winemaker_type') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.wine_maker_type }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.aging_potential">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_aging_potential') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.aging_potential }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_expansion">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_taste') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.wine_expansion }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.contents">
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_content') }}
          </th>
          <td class="pa-3 font-size-m" v-html="product.details.contents"></td>
        </tr>
        <tr
          class="px-3"
          v-if="product.nutritional_data.wine_alcohol_concentration !== null"
        >
          <th class="pa-3" scope="row">
            {{ translate('pdp_attribute_alcohol_content') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ translate('fe_app_pdp_attribute_alc_volume', alcoholContent) }}
            <span v-if="!isAlcoholic">
              <br />
              <a
                class="link-winered"
                :href="links['wine_alcohol_concentration']"
              >
                {{ product.alcohol_content_value }}
              </a>
            </span>
          </td>
        </tr>
        <tr class="px-3" v-if="product.nutritional_data.wine_acid_grams">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_acid_grams') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{
              translate(
                'fe_app_pdp_attribute_gram_per_liter',
                float(product.nutritional_data.wine_acid_grams * 10.0)
              )
            }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.nutritional_data.wine_sugar_grams">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_sugar_grams') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{
              translate(
                'fe_app_pdp_attribute_gram_per_liter',
                float(product.nutritional_data.wine_sugar_grams * 10.0)
              )
            }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.wine_drink_temperature">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_drink_temperature') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ product.details.wine_drink_temperature }}
          </td>
        </tr>
        <tr class="px-3" v-if="product.details.nutritional_note.length > 0">
          <th class="pa-3" scope="row">
            {{ translate('fe_app_pdp_attribute_nutritinal_note') }}
          </th>
          <td class="pa-3 font-size-m font-weight-bold">
            {{ calculated.nutritionalNotes }}
          </td>
        </tr>
        <tr v-if="product.nutritional_data.contains_sulfide">
          <td
            colspan="2"
            class="border-top pa-3 bold text-capitalize text-center"
          >
            {{ translate('pdp_attribute_contains_sulphites') }}
          </td>
        </tr>
        <tr v-if="product.details.distributor">
          <td colspan="2" class="border-top pa-3 bold text-center">
            {{ product.details.distributor }}
          </td>
        </tr>
      </tbody>
    </VTable>
  </div>
</template>

<script>
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'

const ALCOHOLIC_FLAG = 1
const DEALCOHOLISED_FLAG = 2
const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const [
      { default: UtilityHelper },
      {
        PAGE_URL: { FILTER }
      }
    ] = await Promise.all([
      await import('@/services/helpers/UtilityHelper'),
      await import('@/constants/GlobalConstants')
    ])
    cache = { UtilityHelper, FILTER }
    return cache
  }
})()

const _href = async (attribute, value, translate) => {
  const { UtilityHelper, FILTER } = await _getModules()
  return UtilityHelper.formatString(
    FILTER,
    translate('fe_app_pdp_wines').toLowerCase(),
    attribute,
    value
  )
}

export default {
  name: 'Characteristics',
  data() {
    return {
      float: this.float,
      links: {
        country: {}
      }
    }
  },
  computed: {
    ...mapState(usePdpStore, {
      product: 'getApiProduct',
      calculated: 'getCalculated'
    }),
    alcoholContent() {
      const { wine_alcohol_concentration: concentration } =
        this.product.nutritional_data || {}
      const isAlcoholFree = this.product.alcohol_content === DEALCOHOLISED_FLAG

      if (concentration != null && isAlcoholFree) {
        return '< 0,5'
      }

      return this.float(concentration)
    },
    isAlcoholic() {
      return this.product.alcohol_content === ALCOHOLIC_FLAG
    }
  },
  async created() {
    let wine_type = await _href(
      'wine_type',
      this.product.details.wine_type,
      this.translate
    )
    if (!this.isAlcoholic) {
      wine_type = wine_type + '&wine_alcohol_concentration=[*+TO+0.5]'
    }
    this.links = {
      wine_type: wine_type,
      wine_sub_type: await _href(
        'wine_sub_type',
        this.product.details.wine_sub_type,
        this.translate
      ),
      wine_grape_variety: await _href(
        'wine_grape_variety',
        this.product.details.wine_grape_variety,
        this.translate
      ),
      region: await _href(
        'region',
        this.product.details.region,
        this.translate
      ),
      country: await this.calculated.countries?.reduce(
        async (collected, country) => ({
          ...collected,
          [country]: await _href('country', country, this.translate)
        }),
        {}
      ),
      wine_alcohol_concentration: '/alkoholfreier-wein'
    }
  }
}
</script>

<style scoped>
#characteristics-table tr:not(:last-child) {
  border-bottom: 1px solid rgb(var(--v-theme-ash-gray));
}

#characteristics-table tr:hover {
  background-color: rgb(var(--v-theme-creme));
}

.display-md-and-up #characteristics-table td:first-child,
.display-md-and-up th:first-child {
  padding-left: 1rem;
}

#characteristics-table td:first-child,
th:first-child {
  font-weight: 700;
  letter-spacing: 1px;
}

#characteristics-table td:first-child:not(:last-child),
th:first-child:not(:last-child) {
  color: rgb(var(--v-theme-gray));
  text-transform: uppercase;
  font-size: var(--s-font-size);
}
</style>
